/* json-diff.tsx generated by @compiled/babel-plugin v0.17.1 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import React from "react";
import JSONTree from "./json-tree";
import theme from "../theme";
var _15 = "._syazqv97{color:#a6e3a1}";
var _14 = "._1tke1ar4{min-height:1ex}";
var _13 = "._ajmmnqa1{text-decoration-style:solid}";
var _12 = "._1hms1911{text-decoration-line:line-through}";
var _11 = "._4bfu1r31{text-decoration-color:currentColor}";
var _10 = "._azhwidpf{text-indent:0}";
var _9 = "._19bv1l7b{padding-left:3px}";
var _8 = "._n3tdyh40{padding-bottom:2px}";
var _7 = "._u5f31l7b{padding-right:3px}";
var _6 = "._ca0qt94y{padding-top:1px}";
var _5 = "._syaz7i12{color:#f38ba8}";
var _4 = "._bfhk7woi{background-color:rgba(205,214,244,.2)}";
var _3 = "._1e0c1o8l{display:inline-block}";
var _2 = "._syaz5y2n{color:#cdd6f4}";
var _ = "._syaz1u6e{color:#cba6f7}";
var updatedStyles = null;
var Updated = function Updated(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement("span", {
    className: ax(["_syaz1u6e"])
  }, children));
};
var whiteStyles = null;
var White = function White(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2]), /*#__PURE__*/React.createElement("span", {
    className: ax(["_syaz5y2n"])
  }, children));
};
var deletedStyles = null;
var Deleted = function Deleted(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14]), /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c1o8l _bfhk7woi _syaz7i12 _ca0qt94y _u5f31l7b _n3tdyh40 _19bv1l7b _azhwidpf _4bfu1r31 _1hms1911 _ajmmnqa1 _1tke1ar4"])
  }, children));
};
var addedStyles = null;
var Added = function Added(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_3, _4, _15, _6, _7, _8, _9, _10, _14]), /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c1o8l _bfhk7woi _syazqv97 _ca0qt94y _u5f31l7b _n3tdyh40 _19bv1l7b _azhwidpf _1tke1ar4"])
  }, children));
};
function postprocessValue(value) {
  if (value && value._t === "a") {
    var res = {};
    for (var key in value) {
      if (key !== "_t") {
        if (key[0] === "_" && !value[key.substring(1)]) {
          res[key.substring(1)] = value[key];
        } else if (value["_" + key]) {
          res[key] = [value["_" + key][0], value[key][0]];
        } else if (!value["_" + key] && key[0] !== "_") {
          res[key] = value[key];
        }
      }
    }
    return res;
  }
  return value;
}
function labelRenderer(raw) {
  return raw[0];
}
function stringifyAndShrink(val) {
  if (val === null) {
    return "null";
  }
  var str = JSON.stringify(val);
  if (typeof str === "undefined") {
    return "undefined";
  }
  return str.length > 22 ? "".concat(str.substr(0, 15), "\u2026").concat(str.substr(-5)) : str;
}
function getValueString(raw) {
  if (typeof raw === "string") {
    return raw;
  }
  return stringifyAndShrink(raw);
}
function replaceSpacesWithNonBreakingSpace(value) {
  return value.replace(/\s/gm, " ");
}
function parseTextDiff(textDiff) {
  var diffByLines = textDiff.split(/\n/gm).slice(1);
  return diffByLines.map(function (line) {
    var type = line.startsWith("-") ? "delete" : line.startsWith("+") ? "add" : "raw";
    return _defineProperty({}, type, replaceSpacesWithNonBreakingSpace(line.substr(1)));
  });
}
function valueRenderer(raw) {
  if (Array.isArray(raw)) {
    if (raw.length === 1) {
      return /*#__PURE__*/React.createElement(Added, null, getValueString(raw[0]));
    }
    if (raw.length === 2) {
      return /*#__PURE__*/React.createElement(Updated, null, /*#__PURE__*/React.createElement(Deleted, null, getValueString(raw[0])), " =>", " ", /*#__PURE__*/React.createElement(Added, null, getValueString(raw[1])));
    }
    if (raw.length === 3 && raw[1] === 0 && raw[2] === 0) {
      return /*#__PURE__*/React.createElement(Deleted, null, getValueString(raw[0]));
    }
    if (raw.length === 3 && raw[2] === 2) {
      return /*#__PURE__*/React.createElement(Updated, null, "\"", parseTextDiff(raw[0]).map(function (item) {
        if (item["delete"]) {
          return /*#__PURE__*/React.createElement(Deleted, {
            key: item["delete"] + "delete"
          }, item["delete"]);
        }
        if (item.add) {
          return /*#__PURE__*/React.createElement(Added, {
            key: item.add + "add"
          }, item.add);
        }
        return /*#__PURE__*/React.createElement(White, {
          key: item.raw + "raw"
        }, item.raw);
      }), "\"");
    }
  }
  return "" + raw;
}
export function itemsCountString(count) {
  return "".concat(count);
}
export function getItemString(type, _value, defaultView, keysCount) {
  switch (type) {
    case "Object":
      return /*#__PURE__*/React.createElement("span", null, "{…}");
    default:
      return /*#__PURE__*/React.createElement("span", null, defaultView, " ", keysCount);
  }
}
export default function JSONDiff(props) {
  if (!props.delta) return null;
  return /*#__PURE__*/React.createElement(JSONTree, {
    data: props.delta,
    hideRoot: true,
    postprocessValue: postprocessValue,
    labelRenderer: labelRenderer,
    valueRenderer: valueRenderer,
    isCustomNode: Array.isArray,
    getItemString: getItemString,
    shouldExpandNode: function shouldExpandNode() {
      return true;
    }
  });
}